// extracted by mini-css-extract-plugin
export var cardIcon = "_78-4";
export var checkboxCard = "_78-0";
export var checkboxCardSelected = "_78-3";
export var disabled = "_78-1";
export var outerBorder = "_78-2";
export var spacerMedium = "_78-7";
export var spacerSmall = "_78-6";
export var spacerXsmall = "_78-5";